unit View.Cst_Pis.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewCst_PisList = class(TForm)
    btNew: TButton;
    Cst_PisDataset: TXDataWebDataSet;
    Cst_PisDatasetcst_pis_id: TStringField;
    Cst_PisDatasetnome: TStringField;
    Cst_PisDatasetexcluido: TBooleanField;
    Cst_PisDatasetinclusao: TDateTimeField;
    Cst_PisDatasetalteracao: TDateTimeField;
    Cst_PisDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCst_PisList: TFViewCst_PisList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCst_PisList }

procedure TFViewCst_PisList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCst_PisList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCst_PisList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCst_PisList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCst_PisList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCst_PisList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCst_PisList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Cst_PisDataset.Connection.Model.DefaultSchema.FindEntityType(Cst_PisDataset.EntitySetName),
      Cst_PisDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCst_PisList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('cst_pis', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Cst_PisDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCst_PisList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.cst_pis.list.pagination.info');
  btNew := TButton.Create('view.cst_pis.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.cst_pis.list.table');
  cbPageSize := TComboBox.Create('view.cst_pis.list.cbPageSize');
  edSearch := TEdit.Create('view.cst_pis.list.search');
  lcPaginator := TListControl.Create('view.cst_pis.list.pagination');
  Cst_PisDataset := TXDataWebDataSet.Create(Self);
  Cst_PisDatasetcst_pis_id := TStringField.Create(Self);
  Cst_PisDatasetnome := TStringField.Create(Self);
  Cst_PisDatasetexcluido := TBooleanField.Create(Self);
  Cst_PisDatasetinclusao := TDateTimeField.Create(Self);
  Cst_PisDatasetalteracao := TDateTimeField.Create(Self);
  Cst_PisDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Cst_PisDataset.BeforeLoadDFMValues;
  Cst_PisDatasetcst_pis_id.BeforeLoadDFMValues;
  Cst_PisDatasetnome.BeforeLoadDFMValues;
  Cst_PisDatasetexcluido.BeforeLoadDFMValues;
  Cst_PisDatasetinclusao.BeforeLoadDFMValues;
  Cst_PisDatasetalteracao.BeforeLoadDFMValues;
  Cst_PisDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewCst_PisList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_pis_id';
      Title := 'cst_pis_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Cst_PisDataset.SetParentComponent(Self);
    Cst_PisDataset.Name := 'Cst_PisDataset';
    Cst_PisDataset.EntitySetName := 'Cst_Pis';
    Cst_PisDataset.Connection := DMConnection.ApiConnection;
    Cst_PisDataset.Left := 72;
    Cst_PisDataset.Top := 144;
    Cst_PisDatasetcst_pis_id.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetcst_pis_id.Name := 'Cst_PisDatasetcst_pis_id';
    Cst_PisDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Cst_PisDatasetcst_pis_id.Required := True;
    Cst_PisDatasetcst_pis_id.Size := 255;
    Cst_PisDatasetnome.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetnome.Name := 'Cst_PisDatasetnome';
    Cst_PisDatasetnome.FieldName := 'nome';
    Cst_PisDatasetnome.Required := True;
    Cst_PisDatasetnome.Size := 255;
    Cst_PisDatasetexcluido.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetexcluido.Name := 'Cst_PisDatasetexcluido';
    Cst_PisDatasetexcluido.FieldName := 'excluido';
    Cst_PisDatasetinclusao.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetinclusao.Name := 'Cst_PisDatasetinclusao';
    Cst_PisDatasetinclusao.FieldName := 'inclusao';
    Cst_PisDatasetalteracao.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetalteracao.Name := 'Cst_PisDatasetalteracao';
    Cst_PisDatasetalteracao.FieldName := 'alteracao';
    Cst_PisDatasetexclusao.SetParentComponent(Cst_PisDataset);
    Cst_PisDatasetexclusao.Name := 'Cst_PisDatasetexclusao';
    Cst_PisDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Cst_PisDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Cst_PisDataset.AfterLoadDFMValues;
    Cst_PisDatasetcst_pis_id.AfterLoadDFMValues;
    Cst_PisDatasetnome.AfterLoadDFMValues;
    Cst_PisDatasetexcluido.AfterLoadDFMValues;
    Cst_PisDatasetinclusao.AfterLoadDFMValues;
    Cst_PisDatasetalteracao.AfterLoadDFMValues;
    Cst_PisDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
